import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md' : 'bg-white shadow-md'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 sm:py-6">
        <div className="flex items-center justify-between">
          <a href="/" className="cursor-pointer">
            <h1 className="text-2xl sm:text-3xl font-light transition-colors text-gray-900 whitespace-nowrap" style={{ fontFamily: '"Pacifico", serif' }}>
              Heritage Water
            </h1>
          </a>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-2xl transition-colors text-gray-900 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="mt-4 py-4 rounded-lg bg-white">
            <a href="/" className="block px-4 py-3 text-gray-900 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">
              Home
            </a>
            <a href="/about" className="block px-4 py-3 text-teal-600 font-medium hover:bg-teal-50 transition-colors cursor-pointer">
              AboutUs
            </a>
            <a href="/" className="block px-4 py-3 text-gray-900 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">
              Product
            </a>
            <a href="/" className="block px-4 py-3 text-gray-900 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">
              Contact
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
